import {actionTypes, flightTypes, workplaceTypes} from "../types";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'

import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { filterTableWork } from "../functions";
import { VehicleNumberBlock } from "../Block/VehicleNumberBlock";
import { appNotification } from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { cache } from '@/components/Cache.js';
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';

var VehicleFreeTask = {
    time: null,
    list: [],
    error: '',
    init: function (ping) {
        return m.request({
            method: 'GET',
            url: '/api/vehicle/tasks/free'
        }).then(function (response) {
            server.setOnline();

            VehicleFreeTask.time = response.time;
            VehicleFreeTask.list = response.tasks;
            appNotification.list = response.notifications;

            loader.hide();
            storage.config = response.config;

            if (ping) {
                server.initPing();
                appNotification.init();
            }

            return response;
        }, function (response) {
            if (response && response.message) {
                VehicleFreeTask.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    initIntervalRefresh: function () {
        interval.make(function () {
            VehicleFreeTask.init(false)
        }, 30000)
    },
    confirmTask: function (key) {
        VehicleFreeTask.error = '';
        loader.show();

        var task = VehicleFreeTask.list[key];

        m.request({
            method: 'PUT',
            url: '/api/vehicle/task/' + task.id + '/confirm'
        }).then(function (response) {
            if (!response.data) {
                VehicleFreeTask.error = (m(".alert.alert-danger", 'Работа уже назначена на другой транспорт'));
            }
            loader.hide();

            m.route('/task/' + task.id + '/works');

        }, function (response) {

            cache.push({
                type: actionTypes.freeTaskConfirm,
                taskId: task.id
            });

            if (response && response.message) {
                VehicleFreeTask.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    }
};

export var VehicleFreeTasksPage = {
    controller: function () {
        if (!user.exists()) {
            m.route('/login');
            return;
        }
        if (!user.has('state.workplace')) {
            m.route('/workplace');
            return;
        }
        if (!user.get('state.vehicleFreeTasksAvailable')) {
            m.route('/vehicle/tasks');
            return;
        }
        if (user.get('state.workplace') !== workplaceTypes.driver) {
            m.route('/');
            return;
        }

        interval.clearAll();

        loader.show();

        var data = VehicleFreeTask.init(true);

        setTimeout(function () {
            VehicleFreeTask.initIntervalRefresh()
        }, 500);

        return {
            data: data,
            topMenu: [
                { title: 'Свободные', url: '/vehicle/tasks/free', icon: 'fa-car' },
                { title: 'Задачи', url: '/vehicle/tasks', icon: 'fa-tasks' },
                { title: 'Техника', url: '/vehicle', icon: 'fa-truck' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ]
        }
    },
    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                time: VehicleFreeTask.time,
                menu: ctrl.topMenu
            }),
            m("div[style='margin-top:0px']", VehicleFreeTask.error),
            VehicleNumberBlock(),
            m("input[style='width: 98%; margin: 0 1%; height: 35px;'][type='text'] " +
                "[id='inputWorkName'] [placeholder='Поиск..'] [title='Введите имя']", {
                onkeyup: filterTableWork
            }, []),
            m("table.table.table-bordered.table-condensed[id='tableTask']", [
                m("thead", [
                    m("tr", [
                        m("th.text-center", "Работа"),
                        m("th.text-center", "Время"),
                        m("th.text-center", "МС\nВС"),
                        m("th", "")
                    ])
                ]),
                m("tbody", [
                    VehicleFreeTask.list.map(function (task, i) {
                        return m("tr", {class: task.isOverdue ? 'bg-grey' : ''}, [
                            m("td", [
                                m("a.btn.btn-block.btn-lg", {
                                        href: task.url,
                                        class: task.hasAlerts ? 'btn-warning progress-bar-striped' : 'btn-default',
                                        config: m.route
                                    },
                                    task.isCrossWork ? m("i.fa.fa-2x.fa-exclamation") : '',
                                    m("span[style='display:inline-block;padding-left:7px;']", [
                                        m('span', task.flightNumber),
                                        m("br"),
                                        task.flightType === flightTypes.departure ?
                                            [m('img', {src: "/img/departure.png"}), m.trust('&nbsp;' + task.airportCode)] : '',
                                        task.flightType === flightTypes.arrival ?
                                            [m('img', {src: "/img/arrival.png"}), m.trust(task.airportCode + '&nbsp;')] : '',
                                        task.flightType === flightTypes.around ?
                                            [m('img', {src: "/img/around.png"}), m.trust('&nbsp;' + task.airportCode)] : '',
                                        m("br"),
                                        m('span', task.workName)
                                    ])
                                )
                            ]),
                            m("td.text-center.v-center", [
                                m("span.big-text", task.flightTime),
                                m("br"),
                                m("span", task.flightDate),
                                task.EntranceZoneTime ? [
                                    m("br"),
                                    m("span.small-text[style='color:red; font-size:15px']", "Вход АП"),
                                    m("br"),
                                    m("span.small-text[style='color:red; font-size:20px']", task.EntranceZoneTime)] : [],

                            ]),
                            m("td.text-center.v-center", [
                                m("span.big-text", task.parkingNumber),
                                m("br"),
                                m("span", task.typeVS)
                            ]),
                            m("td.col-xs-2.text-center.v-center", [
                                m("button.btn.btn-info", {
                                    onclick: function () {
                                        VehicleFreeTask.confirmTask(i);
                                    }
                                }, [
                                    m("i.fa.fa-2x.fa-thumbs-o-up")
                                ])
                            ])
                        ])
                    })
                ])
            ])
        ];
    }
};
